import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54982d6e")

_pushScopeId("data-v-54982d6e")
const _hoisted_1 = { class: "SendToEmailModal" }
const _hoisted_2 = { class: "SendToEmailModal__header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "header__title" }, " Отправка накладной на почту ", -1)
const _hoisted_4 = { class: "SendToEmailModal__body" }
const _hoisted_5 = { class: "body__action" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Добавить Email ")
const _hoisted_7 = { class: "SendToEmailModal__list" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "list__title" }, " Список электронных почт куда будет отправлена накладная: ", -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "list__empty"
}
const _hoisted_11 = { class: "body__action" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Отправить ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_close = _resolveComponent("icon-close")!
  const _component_s_input = _resolveComponent("s-input")!
  const _component_s_button = _resolveComponent("s-button")!
  const _component_s_checkbox = _resolveComponent("s-checkbox")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock(_component_s_modal, { onClose: _ctx.closeModal }, {
    body: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_icon_close, {
            class: "header__close",
            onClick: _ctx.closeModal
          }, null, 8, ["onClick"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_s_input, {
            placeholder: "Введите E-mail",
            value: _ctx.state.email,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.email = $event)),
            "is-invalid": _ctx.state_form$.email.$error
          }, null, 8, ["value", "is-invalid"]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_s_button, {
              class: "green",
              onClick: _ctx.addEmail
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            (Boolean(_ctx.state.emails_list.length))
              ? (_openBlock(), _createBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.emails_list, (email) => {
                    return (_openBlock(), _createBlock("li", { key: email }, _toDisplayString(email), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_10, "Вы ещё не указали электронные почты")),
            _createVNode(_component_s_checkbox, {
              theme: "green",
              label: "Отправить себе",
              value: _ctx.state.should_be_send_to_owner,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.should_be_send_to_owner = $event))
            }, null, 8, ["value"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_s_button, {
              class: "green",
              disabled: !_ctx.state.emails_list.length && !_ctx.state.should_be_send_to_owner,
              loading: _ctx.state.is_loading,
              onClick: _ctx.submit
            }, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})